export class FieldSyncUpdateAssetCommand {
    constructor(asset) {
        this.asset = asset;
    }
}
//# sourceMappingURL=field-sync-update-asset.command.js.map